module.exports = __webpack_public_path__ + "static/media/to_do_list_java.3bdecb2c.png";